"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLogisticOrderLogisticCost = void 0;
const calculate_advanced_cost_1 = require("./calculate-advanced-cost");
const calculate_standard_cost_1 = require("./calculate-standard-cost");
const calculateLogisticOrderLogisticCost = lines => {
    const standardCost = (0, calculate_standard_cost_1.computeAllStandardCost)(lines);
    if (standardCost !== Infinity)
        return standardCost.toString();
    const advancedCost = (0, calculate_advanced_cost_1.computeAllAdvancedCost)(lines);
    return advancedCost.toNumber() >= 0 ? advancedCost.toString() : '0';
};
exports.calculateLogisticOrderLogisticCost = calculateLogisticOrderLogisticCost;
